import React, { Component } from "react";
import {
  Layout,
  Col,
  Row,
  Typography,
  List,
  message,
  Card,
  Dropdown,
  Button,
  Menu,
  Modal,
} from "antd";
import { MoreOutlined } from "@ant-design/icons";

//componentes
import { renderEstatusOrdenCompra } from "../../../Utils";
import ModalProveedor from "../../Compras/ModalProveedor";
import DrawerOrdenCompra from "../../Compras/DrawerOrdenCompra";
import ModalOrdenCompraDetelles from "./ModalOrdenCompraDetelles";
import ModalRecepcionOrdenesCompras from "./ModalRecepcionesOrdenesCompras";
import ModalAlmacen from "../../ProjectManager/AccountPurchase/ModalAlmacen";

const { Content } = Layout;
const { Text } = Typography;
const moment = require("moment");
const axios = require("axios");

/**
 * @export
 * @class OrdenesComprasList
 * @extends {Component}
 * @description Vista que lista las ordenes de comrpas relacionadas al cliente
 */
export default class OrdenesComprasList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      ordenes_compras: {
        data: [],
        page: 1,
        limit: 10,
        total: 0,
        pages: 0,
      },
      almacen_id: undefined,
      orden_compra_id: undefined,
      drawerOrdenCompraVisible: undefined,
    };
  }

  componentDidMount() {
    axios.defaults.headers.common["Authorization"] = sessionStorage.getItem("token");
    this.getOrdenesCompras();
  }

  componentDidUpdate = () => {};

  /**
   *
   *
   * @memberof OrdenesComprasList
   * @method getOrdenesCompras
   * @description Obtener las solicitudes del id de una inventario dado
   */
  getOrdenesCompras = (
    {
      page = this.state.ordenes_compras.page,
      limit = this.state.ordenes_compras.limit,
      search = this.props.search,
    } = this.state.ordenes_compras
  ) => {
    this.setState({ loading: true });

    axios
      .get("/ordenesCompra/list-v2", {
        params: {
          cliente_id: this.props.cliente_id,
          page,
          limit,
          search,
        },
      })
      .then(({ data }) => {
        console.log("data", data);
        this.setState({
          ordenes_compras: data,
        });
      })
      .catch((error) => {
        message.error("Error al obtener las ordenes de compras");
        console.log(error);
      })
      .finally(() => this.setState({ loading: false }));
  };

  /**
   * @memberof OrdenesComprasList
   * @method sendEmail
   * @description Envia una orden de compra por email
   */
  sendEmail = (id) => {
    return axios
      .get("/ordenesCompra/purchase-order", {
        params: {
          orden_compra_id: id,
          enviar: true,
        },
      })
      .then((response) => {
        message.success("Orden Enviada");
        this.getCompras();
      })
      .catch((error) => {
        console.log(error);
        message.error("Error al enviar  orden");
      });
  };

  /**
   * @memberof OrdenesComprasList
   * @method getPDF
   * @description Obtiene le PDF de la orden de compra
   */
  getPDF = (id) => {
    let url = new URL(axios.defaults.baseURL + "/ordenesCompra/purchase-order");
    url.searchParams.append("orden_compra_id", id);
    url.searchParams.append("Authorization", sessionStorage.getItem("token"));
    window.open(url, "_blank");
  };

  /**
   * @memberof OrdenesComprasList
   * @method deleteOrdenCompra
   * @description Elimina la orden de comrpa
   */
  deleteOrdenCompra = (id) => {
    Modal.confirm({
      title: "¿Deseas eliminar esta Orden de Compra?",
      content: "Si no hay una orden o un reporte relacionado, se eliminarán los registros de los productos",
      okText: "Aceptar",
      cancelText: "Cancelar",
      onOk: () => {
        return axios
          .post("/ordenesCompra/delete", {
            id: id,
          })
          .then(() => {
            message.success("Eliminado correctamente");
            this.getOrdenesCompras();
          }).catch(()=>{
            message.error("Error al eliminar la orden de compra")
          });
      },
    });
  };

  /**
   * @memberof OrdenesComprasList
   * @method closeModals
   * @description Cierra todos los modales
   */
  closeModals = () => {
    this.setState({
      orden_compra_id: null,
      proveedor_id: undefined,
      almacen_id: undefined,
      drawerOrdenCompraVisible: false,
      modalProveedorVisible: false,
      modalAlmacenVisible: false,
      modalRecepcionVisible: false,
      modalOrdenCompraDetellesVisible: false,
    });
  };

  render() {
    return (
      <>
        <Content>
          <Row>
            <Col span={24}>
              <List
                loading={this.state.loading}
                className="component-list lista-vmi"
                locale={{ emptyText: "Sin Ordenes Compras" }}
                itemLayout="horizontal"
                dataSource={this.state.ordenes_compras.data}
                pagination={{
                  current: this.state.ordenes_compras.page,
                  pageSize: this.state.ordenes_compras.limit,
                  total: this.state.ordenes_compras.total,
                  hideOnSinglePage: false,
                  showSizeChanger: true,
                  position: "bottom",
                  className: "flex-left",
                  onChange: (page, limit) =>
                    this.getOrdenesCompras({ page, limit }),
                }}
                header={
                  <Row className="header-list width-100 pl-1 pr-1 ">
                    <Col span={3} className="center">
                      <Text strong>Folio</Text>
                    </Col>
                    <Col span={4} className=" center">
                      <Text strong>Fecha</Text>
                    </Col>
                    <Col span={4} className="center">
                      <Text strong>Proveedor</Text>
                    </Col>
                    <Col span={3} className="center">
                      <Text strong>Productos</Text>
                    </Col>
                    <Col span={4} className="center">
                      <Text strong>Total</Text>
                    </Col>
                    <Col span={3} className="center">
                      <Text strong>Estatus</Text>
                    </Col>
                    <Col span={3} className="center">
                      <Text strong>Acciones</Text>
                    </Col>
                  </Row>
                }
                renderItem={(item) => (
                  <List.Item className="component-list-item">
                    <Card className="card-list">
                      <div className={`badge-card tipo-${item?.tipo}`}></div>
                      <Row className="width-100">
                        <Col span={3} className="flex-column">
                          <Text strong>{item?.folio}</Text>
                          <Text className="text-gray">{item?.orden_id?.folio ? `Orden: ${item?.orden_id?.folio}` : null}</Text>
                        </Col>
                        <Col span={4} className="flex-column">
                          <Text strong>
                            {moment(item?.createdAt).format("DD/MM/YYYY")}
                          </Text>
                          <Text className="text-gray">{item?.fecha_entrega ? `Fecha Entrega: ${moment(item?.fecha_entrega).format("DD/MM/YYYY")}` : null}</Text>
                        </Col>
                        <Col xs={4} className="center">
                          <Text>{item?.proveedor_id?.nombre}</Text>
                        </Col>
                        <Col xs={3} className="center">
                          <Text>{item?.orden_detalles_count}</Text>
                        </Col>
                        <Col xs={4} className="center">
                          <Text className="text-gray-dark">
                            $ {item?.monto_total?.toMoney(true)} MXN
                          </Text>
                        </Col>
                        <Col xs={3} className="center">
                          {renderEstatusOrdenCompra(item?.estatus)}
                        </Col>
                        <Col xs={3} className="center">
                          <Dropdown
                            placement="topRight"
                            trigger={["click"]}
                            overlay={
                              <Menu>
                                <Menu.Item
                                  onClick={() => {
                                    this.setState({
                                      modalOrdenCompraDetellesVisible: true,
                                      orden_compra_id: item?._id,
                                    });
                                  }}
                                >
                                  Ver Detalles
                                </Menu.Item>
                                <Menu.Item
                                  onClick={() =>
                                    this.setState({
                                      drawerOrdenCompraVisible: true,
                                      orden_compra_id: item?._id,
                                    })
                                  }
                                >
                                  Editar Orden de Compra
                                </Menu.Item>
                                <Menu.Item
                                  onClick={() =>
                                    this.setState({
                                      modalProveedorVisible: true,
                                      proveedor_id: item?.proveedor_id?._id,
                                    })
                                  }
                                >
                                  Editar Proveedor
                                </Menu.Item>
                                <Menu.Item
                                  onClick={() => this.sendEmail(item._id)}
                                >
                                  Enviar la orden de Compra al proveedor
                                </Menu.Item>
                                <Menu.Item
                                  onClick={() => this.getPDF(item._id)}
                                >
                                  Ver el PDF
                                </Menu.Item>
                                <Menu.Item
                                  onClick={() => {
                                    this.setState({
                                      modalAlmacenVisible: true,
                                      orden_compra_id: item?._id,
                                      almacen_id: item.almacen_id,
                                    });
                                  }}
                                >
                                  Asignar Almacen de llegada
                                </Menu.Item>
                                <Menu.Item
                                  onClick={() => {
                                    this.setState({
                                      modalRecepcionVisible: true,
                                      orden_compra_id: item?._id,
                                    });
                                  }}
                                >
                                  Recepciones de Orden de Compra
                                </Menu.Item>
                                <Menu.Item
                                  onClick={()=>this.deleteOrdenCompra(item?._id)}
                                >Eliminar Orden</Menu.Item>
                              </Menu>
                            }
                          >
                            <Button icon={<MoreOutlined style={{color: "black"}}/>} style={{border: "none"}}/>
                          </Dropdown>
                        </Col>
                      </Row>
                    </Card>
                  </List.Item>
                )}
              />
            </Col>
          </Row>
        </Content>
        <DrawerOrdenCompra
          orden_compra_id={this.state.orden_compra_id}
          visible={this.state.drawerOrdenCompraVisible}
          onSave={() => {
            this.closeModals();
            this.getOrdenesCompras();
          }}
          onClose={() => this.closeModals()}
        />
        <ModalProveedor
          visible={this.state.modalProveedorVisible}
          proveedor_id={this.state.proveedor_id}
          onClose={() => {
            this.closeModals();
            this.getOrdenesCompras();
          }}
        />
        <ModalAlmacen
          visible={this.state.modalAlmacenVisible}
          cliente_id={this.props.cliente_id}
          orden_compra_id={this.state.orden_compra_id}
          almacen_id={this.state.almacen_id}
          onClose={() => {
            this.closeModals();
            this.getOrdenesCompras();
          }}
        />
        <ModalRecepcionOrdenesCompras
          orden_compra_id={this.state.orden_compra_id}
          visible={this.state.modalRecepcionVisible}
          onClose={() => {
            this.closeModals();
            this.getOrdenesCompras();
          }}
        />
        <ModalOrdenCompraDetelles
          orden_compra_id={this.state.orden_compra_id}
          visible={this.state.modalOrdenCompraDetellesVisible}
          onClose={() => {
            this.closeModals();
          }}
        />
      </>
    );
  }
}
